var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCywTiwbHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 229 239",
    style: {
      enableBackground: "new 0 0 229 239"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.2;fill:#2A2A27;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FDDD00;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 114.5,
    cy: 124.5,
    r: 114.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 114.5,
    cy: 114.5,
    r: 114.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 114.5,
    cy: 114.5,
    r: 84.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M98.3,161.1H79.6c-2.6,0-4.7-2.1-4.7-4.7v-36.1c0-2.6-2.1-4.7-4.7-4.7h0c-4.3,0-6.4-5.3-3.2-8.2l44.4-40 c1.8-1.6,4.5-1.6,6.3,0l44.4,40c3.2,2.9,1.2,8.2-3.2,8.2h0c-2.6,0-4.7,2.1-4.7,4.7v36.1c0,2.6-2.1,4.7-4.7,4.7h-18.8 c-2.6,0-4.7-2.1-4.7-4.7v-24.6c0-2.6-2.1-4.7-4.7-4.7h-13.4c-2.6,0-4.7,2.1-4.7,4.7v24.6C103.1,159,100.9,161.1,98.3,161.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCywTiwbHome);
export default __webpack_public_path__ + "static/media/cywTiwbHome.9b3c3acfd5eb25666205194e8a69c880.svg";
export { ForwardRef as ReactComponent };